import { FormControl, FormLabel, Grid, Radio, RadioGroup } from "@mui/material";
import { StyledFormControlLabel } from "./styledComponents";
import ProjectIssueLevels from "./ProjectIssueLevels";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import { useContext } from "react";
import SettingsContext from "@/Contexts/Settings/Context";
import PermissionContext from "@/Contexts/Permissions";
import { PermissionActionEnum, PermissionEntityEnum } from "@/graphql/generated/graphql";

const GlobalSettingsSection: React.FC = () => {
  const { permissionMatrixLayoutValue, defaultCurrencyValue, handleCompanySettingChange } = useContext(SettingsContext);
  const { canPerformAction } = useContext(PermissionContext);
  const { Manage } = PermissionActionEnum;
  const { CompanySettings } = PermissionEntityEnum;
  const hasPermission = canPerformAction(Manage, CompanySettings);

  return (
    <Grid container direction='column'>
      <Grid size={4} mb={2}>
        <FormControl>
          <FormLabel id="radio-buttons-permission-matrix">Permission System Layout</FormLabel>
          <RadioGroup
            aria-labelledby="radio-buttons-permission-matrix"
            value={permissionMatrixLayoutValue}
            name="permission-matrix-radios"
            onChange={(_, value) => handleCompanySettingChange('permission-matrix-layout', value)}
          >
            <StyledFormControlLabel value="list" control={<Radio disabled={!hasPermission} />} label="List Based Permission" />
            <StyledFormControlLabel value="grid" control={<Radio disabled={!hasPermission} />} label="Grid Based Layout" />
            <StyledFormControlLabel value="hybrid" control={<Radio disabled={!hasPermission} />} label="Hybrid Layout" />
          </RadioGroup>
        </FormControl>
      </Grid>
      <ProjectIssueLevels />
      <FormControl fullWidth>
        <InputLabel id="currency-label">Currency Symbol</InputLabel>
        <Select
          labelId="currency-label"
          id="currency-select"
          value={defaultCurrencyValue}
          label="Default Currency"
          onChange={(event) => handleCompanySettingChange("default-currency", event.target.value as string)}
          disabled={!hasPermission}
        >
          <MenuItem value="£">GBP (£)</MenuItem>
          <MenuItem value="€">EUR (€)</MenuItem>
          <MenuItem value="$">USD ($)</MenuItem>
        </Select>
      </FormControl>
    </Grid>
  );
}

export default GlobalSettingsSection
